import React, {useContext, useState} from 'react'
import {observer} from 'mobx-react'
import PatientPageStore from '../Store/PatientPageStore'
import moment from 'moment'
import {useHttp} from '../../../../hooks/http.hook'
import {AuthContext} from '../../../../context/AuthContext'
import Modal from '../../../../components/Modal'
import FormInput from '../../../../components/Inputs/FormInput/FormInput'
import {Form, Formik} from 'formik'
import CloseButton from '../../../../components/Buttons/CloseButton/CloseButton'
import {io} from 'socket.io-client'
import styled from 'styled-components'
import Button from '../../../../components/Button'
import DateInput from '../../../../components/DateInput'
import {SnilsInput} from "../../../../components/Inputs/SnilsInput";

function requestToSocketServer(host, response) {
    const socket = io.connect(host, {path: '/socket'})
    socket.emit('addNewRequest', response)
}

const ChangeUserInfoModal = observer((props) => {
    const userData = {...PatientPageStore.patientInfo}
    const {token, userId} = useContext(AuthContext)
    const {request} = useHttp()
    const baseURL = process.env.REACT_APP_BASE_URL
    const [completed, setCompleted] = useState(false)

    const changePatientInfoRequest = async (formData) => {
        const url = `${baseURL}/api/v2/patients/${userId}/info`
        const {data, status} = await request(url, 'PUT', formData, {Authorization: `Bearer ${token}`})
        data?.message === 'Данные отправлены на проверку.' && setCompleted(true)
        return {data, status}
    }


    return (
        <Modal>
            <div className='formModal'>
                <div className='auth__form'>
                    <CloseButton onClick={() => {
                        PatientPageStore.closePatientInfoChangeModal()
                    }}/>
                    <div className='formModal__title'>Изменение данных</div>
                    {completed
                        ? (
                            <CompleteText>
                                Ваши изменения отправлены на проверку, после успешной проверки данные обновятся
                                автоматически. Статус
                                обновления данных можно отслеживать во вкладке уведомления.
                                <Button onClick={() => {
                                    PatientPageStore.closePatientInfoChangeModal()
                                }} text={'Продолжить'}/>
                            </CompleteText>
                        )
                        : (
                            <Formik
                                initialValues={{
                                    fio: userData.fio,
                                    dob: moment(userData.dob).format('YYYY-MM-DD'),
                                    med_book: userData.med_book,
                                    snils: userData.snils,
                                    address: userData.address
                                }}
                                onSubmit={async (values) => {
                                    changePatientInfoRequest(values)
                                        .then(response => {
                                                if (response.status === 200) {
                                                    requestToSocketServer(process.env.REACT_APP_SOCKET_HOST, response?.data?.data[0])
                                                    // window.location.href = window.location.href
                                                }
                                            }
                                        )
                                }}>

                                {props1 =>
                                    <Form className={'auth__login-form auth__client__login-form'}>

                                        <FormInput hideIcon={true}
                                                   name={'fio'}
                                                   important
                                                   defaultValue={props1.values.fio}
                                                   onChange={props1.handleChange}
                                                   required={true}>
                                            ФИО
                                        </FormInput>

                                        <FormInput hideIcon={true}
                                                   name={'med_book'}
                                                   defaultValue={props1.values.med_book}
                                                   onChange={props1.handleChange}
                                                   maxLength={10}
                                                   minLength={6}
                                                   type={'text'}
                                        >
                                            Медицнская книжка
                                        </FormInput>

                                        <DateInput
                                            title='Дата рождения'
                                            value={moment(props1.values.dob, 'YYYY-MM-DD')}
                                            onChange={date => props1.setValues(data => ({
                                                ...data,
                                                dob: moment(date).format('YYYY-MM-DD')
                                            }))}
                                            name={'dob'}
                                            important
                                        />
                                        {/*<FormInput hideIcon={true}*/}
                                        {/*           defaultValue={props1.values.dob}*/}
                                        {/*           onChange={props1.handleChange}*/}
                                        {/*           name={'dob'}*/}
                                        {/*           type={'date'}*/}
                                        {/*           important*/}
                                        {/*           max={moment().format('YYYY-MM-DD')}*/}
                                        {/*           min='1900-01-01'*/}
                                        {/*           required={true}>*/}
                                        {/*  Дата рождения*/}
                                        {/*</FormInput>*/}

                                        <SnilsInput hideIcon={true}
                                                    name={'snils'}
                                                    defaultValue={props1?.values?.snils}
                                                    onChange={props1?.handleChange}
                                                    type={'text'}
                                        >
                                            СНИЛС
                                        </SnilsInput>

                                        <FormInput hideIcon={true}
                                                   name={'address'}
                                                   defaultValue={props1.values.address}
                                                   onChange={props1.handleChange}
                                        >
                                            Адрес
                                        </FormInput>

                                        <div className='form-buttons'>
                                            <button
                                                disabled={props.submitDisabled}
                                                className='sign-in__button'
                                                type='submit'>
                                                Потвердить
                                            </button>
                                        </div>
                                    </Form>}
                            </Formik>
                        )}
                </div>
            </div>
        </Modal>
    )
})

export default ChangeUserInfoModal

const CompleteText = styled.div`

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  text-align: center;
  padding-left: 30px;
  padding-right: 30px;

  button {
    margin-top: 50px;
    margin-bottom: 50px;
  }
`